"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultEmbedCodeErrorCheck = exports.defaultEmbedUrlErrorCheck = void 0;

var defaultEmbedUrlErrorCheck = function defaultEmbedUrlErrorCheck(url) {
  /* eslint-disable no-script-url */
  var doesNotContainScript = url && url.indexOf('javascript:') === -1;
  var urlIsNotEmpty = url && url.trim().length > 0;
  return urlIsNotEmpty && doesNotContainScript;
};

exports.defaultEmbedUrlErrorCheck = defaultEmbedUrlErrorCheck;

var defaultEmbedCodeErrorCheck = function defaultEmbedCodeErrorCheck(embed) {
  var embedIsNotEmpty = embed && embed.trim().length > 0;
  return embedIsNotEmpty;
};

exports.defaultEmbedCodeErrorCheck = defaultEmbedCodeErrorCheck;